import { useParams, Link } from "react-router-dom";
import { ArrowLeft, CalendarDays, Phone } from "lucide-react";
import { BLOG_POSTS, CONTACT } from "../data";
import { Reveal } from "../components/Reveal";
import { SpeakButton } from "../components/SpeakButton";
import { CTABand } from "../components/CTABand";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG_POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div data-testid="blog-post-not-found" className="max-w-3xl mx-auto px-5 py-32 text-center">
        <h1 className="font-heading font-extrabold text-3xl text-foreground">Article not found</h1>
        <Link to="/blog" className="mt-6 inline-flex items-center gap-2 text-accent font-bold">
          <ArrowLeft className="h-5 w-5" /> Back to all guides
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="blog-post-page">
      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-16 lg:py-20">
        <Reveal>
          <Link
            to="/blog"
            data-testid="blog-back-link"
            className="inline-flex items-center gap-2 text-accent font-bold mb-8 hover:gap-3 transition-all"
          >
            <ArrowLeft className="h-5 w-5" /> All guides
          </Link>
          <div className="flex items-center gap-3 mb-5">
            <span className="rounded-full bg-accent/10 text-accent font-semibold px-3 py-1 text-sm">
              {post.category}
            </span>
            <span className="flex items-center gap-1.5 text-muted-foreground text-sm">
              <CalendarDays className="h-4 w-4" /> {post.date}
            </span>
          </div>
          <h1 className="font-heading font-extrabold text-foreground text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
            {post.title}
          </h1>
          <img
            src={post.image}
            alt={post.title}
            className="mt-8 rounded-[2rem] w-full h-72 sm:h-96 object-cover shadow-xl"
          />
          <div className="mt-8">
            <SpeakButton
              text={`${post.title}. ${post.body.join(" ")}`}
              label="Read this article aloud"
              testId="blogpost-speak"
            />
          </div>
          <div className="mt-10 space-y-6">
            {post.body.map((para, i) => (
              <p key={`${post.slug}-p${i}`} className="text-slate-300 text-lg leading-relaxed">
                {para}
              </p>
            ))}
          </div>

          <div className="mt-12 rounded-2xl bg-secondary border border-border p-8 flex flex-col sm:flex-row items-center justify-between gap-5">
            <p className="font-heading font-bold text-xl text-foreground text-center sm:text-left">
              Want a hand with this? We're happy to help.
            </p>
            <a
              href={CONTACT.phoneHref}
              data-testid="blog-post-call"
              className="inline-flex items-center gap-2 h-14 px-8 rounded-full bg-accent text-white font-bold text-lg hover:bg-[hsl(196,82%,27%)] transition-colors whitespace-nowrap"
            >
              <Phone className="h-5 w-5" /> Call {CONTACT.phone}
            </a>
          </div>
        </Reveal>
      </article>

      <CTABand />
    </div>
  );
}
